import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminApprovals = lazy(() => import("@/pages/admin/AdminApprovals"));
import { AdminLayout } from "@/components/admin/AdminLayout";
export const Route = createFileRoute("/admin/approvals")({
  component: () => (
    <AdminLayout requiredPermission="view_audit_logs">
      <AdminApprovals />
    </AdminLayout>
  ),
});
